<script setup lang="ts"/>

<template>
  <div style="display:none">{{ cpt_preferredLanguage }}</div>
  <div class="control has-icons-left" v-if="!loggedIn">
    <div class="locale-changer select">
      <select id="locale-changer" v-model="$i18n.locale" @change="setUserLocale"> <!-- this.$formkit.setLocale($i18n.locale)"> -->
        <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang.code">
          {{ lang.text }}
        </option>
      </select>
    </div>
    <span class="icon is-left">
            <font-awesome-icon icon="globe"/>
    </span>
  </div>
</template>

<script>

export default {
  name: "locale-changer",
  data() {
    return {
      langs: [
        { code: "en", text: "English" },
        { code: "lb", text: "Luxemburgish" },
        { code: "de", text: "Deutsch" },
        { code: "fr", text: "Francais" },
      ],
      locales: ['en', 'de', 'fr', 'lb', ]
    };
  },
  methods: {
    setUserLocale() {
      this.$formkit.setLocale(this.$i18n.locale);
      localStorage.setItem('user-locale', this.$i18n.locale)

    },
    isLocaleSupported(locale) {
      return this.locales.includes(locale)
    },
    getUserLocale() {
      const locale = window.navigator.language ||
          window.navigator.userLanguage ||
          'en'
      console.log("UserLocale:", locale)
      return {
        locale: locale,
        localeNoRegion: locale.split('-')[0]
      }
    },
    getPersistedLocale() {
      const persistedLocale = localStorage.getItem('user-locale')
      console.log("persisted Locale:", persistedLocale)
      if (this.isLocaleSupported(persistedLocale)) {
        return persistedLocale
      } else {
        return null
      }
    },
    guessDefaultLocale() {
      const userPersistedLocale = this.getPersistedLocale()
      if (userPersistedLocale) {
        return userPersistedLocale
      }
      const userPreferredLocale = this.getUserLocale()
      if (this.isLocaleSupported(userPreferredLocale.locale)) {
        return userPreferredLocale.locale
      }
      if (this.isLocaleSupported(userPreferredLocale.localeNoRegion)) {
        return userPreferredLocale.localeNoRegion
      }
      return 'en'
    }
  },
  computed: {
    loggedIn() {
        // console.log("Checking if logged in:", this.$store.getters['auth/isAuthenticated']);
        return this.$store.getters['auth/isAuthenticated'];
    },
    cpt_preferredLanguage() {
      const ui = this.$store.getters['auth/getUserInfo'];
      if (ui) {
        if (ui.preferredLanguage !== null) {
          console.log("LocaleChanger: Setting language via preferredLanugage to ", ui.preferredLanguage);
          this.$i18n.locale = ui.preferredLanguage;
          localStorage.setItem('user-locale', this.$i18n.locale)
          return ui.preferredLanguage;
        } else {
          return this.guessDefaultLocale();
        }
      }
      return this.guessDefaultLocale();
    },
  },
  mounted() {
    this.$i18n.locale = this.guessDefaultLocale();
  }
};
</script>